import React, {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfo} from "@fortawesome/free-solid-svg-icons";

export function SelectEnum({value, values, onChange}: { value: string, values: any[], onChange: (val: string) => void }) {
    function findValue(value: string) {
        return values.find(v => v.name === value);
    }

    return (
        <select value={value} onChange={e => onChange(e.target.value)}>
            {values.map((val, idx) =>
                <option  selected={value === val.name} key={idx} value={val.name}>{val.name}</option>
            )}
        </select>
    );
}

export function TextEditor({value, setter, readOnly, inputType = "text", size=30}: { value: any, setter: (e: any) => void, readOnly: boolean, inputType?: string, size?: number }) {
    const [text, setText] = useState("");

    useEffect(() => {
        setText(value?.toString());
    });

    if(readOnly) {
        return <span>{text}</span>;
    } else {
        return <input size={size} type={inputType} value={text} onChange={setter}/>
    }
}

export function Tooltip({ text }: { text: string })
{
    return <div className="tooltip"><FontAwesomeIcon icon={faInfo}/>
        <span className="tooltiptext">{text}</span>
    </div>
}

// Helper function to safely parse numeric input
export function safeParseNumber(value: any, defaultValue: number = 0, min: number | null = null, max: number | null = null) {
    // Handle empty string or null/undefined
    if (value === '' || value === null || value === undefined) {
        return defaultValue;
    }

    const parsed = parseFloat(value);

    // Check if the result is NaN
    if (isNaN(parsed)) {
        return defaultValue;
    }

    // Apply min/max constraints if provided
    let result = parsed;
    if (min !== null && result < min) {
        result = min;
    }
    if (max !== null && result > max) {
        result = max;
    }

    return result;
}

export function fixedToHalves(v: number | null | undefined) {
    if(v === null || v === undefined) return 0;
    // once we get to 30g, halves don't make a difference
    if(v > 30) return Number(v.toFixed(0));
    return Math.round(v * 2) / 2;
}